/**
 * Provenance filter for Job records (frontend mirror of base44/shared/jobProvenance.ts).
 *
 * Demo/seed jobs are excluded from public counts, salary statistics, employer
 * discovery, SEO landing pages and structured data. Alliance feed jobs remain
 * public — they are legitimate marketplace inventory.
 *
 * Reads only the stored `record_origin` field so the frontend and the backend
 * sitemaps always agree on the same set of records.
 */
export const DEMO_SEED_ORIGIN = 'demo_seed';

export function isPublicJob(job) {
  return job?.record_origin !== DEMO_SEED_ORIGIN;
}

export function publicJobsOnly(jobs) {
  return (jobs || []).filter(isPublicJob);
}